import { AppState } from '@Redux/store';
import { Book } from '@Models';

export const getBookSelector = (state: AppState): Book | null => {
  return state.book.entity ?? null;
};
